import { render, staticRenderFns } from "./CRUDTemplatesRecebidos.vue?vue&type=template&id=f0b8ad12&"
import script from "./CRUDTemplatesRecebidos.vue?vue&type=script&lang=js&"
export * from "./CRUDTemplatesRecebidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports